export default "__VITE_ASSET__BXJ7Z2IN__"